// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "wrapper-_mc9g";
var _5 = "text-cWNUG";
var _6 = "scrollBody-677If";
var _7 = "title-33sv0";
var _8 = "buttons-3uMEI";
var _9 = "confirmButton-YY2VT";
var _a = "cancelButton-3XjOV";
var _b = "paper-2TAVv";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "wrapper", _5 as "text", _6 as "scrollBody", _7 as "title", _8 as "buttons", _9 as "confirmButton", _a as "cancelButton", _b as "paper" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "wrapper": _4, "text": _5, "scrollBody": _6, "title": _7, "buttons": _8, "confirmButton": _9, "cancelButton": _a, "paper": _b }
